import { CALL_API } from 'redux-api-middleware'
import { get } from 'utils/network'

export const fetchFees = (search) => (dispatch, getState) => {
  if (getState().fee.get('hasFetched')) {
    return Promise.resolve()
  }
  const request = get('/fees')
  request.types = ['FEE_REQ', 'FEE_GET_SUCC', 'NOTIF_FAIL']
  return dispatch({ [CALL_API]: request })
}



// WEBPACK FOOTER //
// ./src/containers/Fees/actions.js